module.exports = __webpack_public_path__ + "ki.svg?4f47a3dbd855e14cb4362e51b81ef78a";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ki.svg
// module id = 1293
// module chunks = 27